import uuid from 'uuid';
import { argumentTypes } from '../config';

export const getDefaultArgumentData = () => ({
  name: '',
  description: '',
  type: argumentTypes[0],
  is_required: true,
  id: uuid.v4(),
  type_data: []
});

export const getDefaultReplyData = () => [
  {
    description: '',
    type: 'external',
    is_resolution: false
  }
  // {
  //   description: '',
  //   type: 'internal',
  //   is_resolution: false
  // }
];

export const getDefaultVariationData = () => ({
  is_default: true,
  is_all_clients: true,
  clients: [],
  url: '',
  approval: {
    id: null,
    name: 'Approval for: Default',
    is_active: false,
    contact_types: []
  },
  name: 'Default',
  arguments: [getDefaultArgumentData()],
  replies: getDefaultReplyData()
});
